import { render } from "./ThanksPage.vue?vue&type=template&id=47312cb2&scoped=true"
import script from "./ThanksPage.vue?vue&type=script&lang=ts"
export * from "./ThanksPage.vue?vue&type=script&lang=ts"

import "./ThanksPage.vue?vue&type=style&index=0&id=47312cb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47312cb2"

export default script